import { datadogRum } from '@datadog/browser-rum';
import { logger } from '../utils/logger';
import {
  useThemeStore,
  useTokenStore,
  useUserStore,
} from '../hooks/useStore.ts';
import { getAbType } from './abTest';
import { NativeState } from '@/native/nativeState.ts';

export type BridgeEventCallbackName =
  | 'GET_TOKEN_CALLBACK'
  | 'UPDATE_TOKEN_CALLBACK'
  | 'GET_NAME_CALLBACK'
  | 'REFRESH_VIEW_CALLBACK'
  | 'GET_THEME_CALLBACK'
  | 'GET_TEXT_MODE_CALLBACK';

const handleGetToken = (data: any) => {
  logger.debug(data);
  useTokenStore.setState({ token: data.token });
  useUserStore.setState({ isAgreed: data.isAgreed, isAdult: data.isAdult });

  const event = new CustomEvent('GET_TOKEN_CALLBACK', {
    detail: {
      token: data.token,
      isAgreed: data.isAgreed,
      isAdult: data.isAdult,
    },
  });
  window.dispatchEvent(event);
};

const handleUpdateToken = (data: any) => {
  useTokenStore.setState({ token: data.token });
  useUserStore.setState({ isAgreed: data.isAgreed, isAdult: data.isAdult });

  const event = new CustomEvent('UPDATE_TOKEN_CALLBACK', {
    detail: {
      token: data.token,
      isAgreed: data.isAgreed,
      isAdult: data.isAdult,
    },
  });
  window.dispatchEvent(event);
};

const handleGetName = (data: any) => {
  logger.debug(data);
  const event = new CustomEvent('GET_NAME_CALLBACK', {
    detail: { names: data.names },
  });
  window.dispatchEvent(event);
};

const handleRefreshView = (data: any) => {
  logger.debug(data);
  useUserStore.setState({ isAgreed: data.isAgreed });
  const event = new CustomEvent('REFRESH_VIEW_CALLBACK', {
    detail: { isAgreed: data.isAgreed },
  });
  window.dispatchEvent(event);
};

const handleSetTheme = (theme: NativeState['Theme']) => {
  logger.debug(theme);
  useThemeStore.setState({ theme });
};

const handleGetTheme = (data: any) => {
  logger.debug(data);
  useThemeStore.setState({ theme: data.theme });

  const event = new CustomEvent('GET_THEME_CALLBACK', {
    detail: { isDarkMode: data.isDarkMode },
  });
  window.dispatchEvent(event);
};

const handleGetTextMode = async (data: any) => {
  const event = new CustomEvent('GET_TEXT_MODE_CALLBACK', {
    detail: { isLargeTextMode: data.isLargeTextMode },
  });
  window.dispatchEvent(event);
};

const handleGetConfig = async (data: any) => {
  logger.debug('datadog userId data:', data);
  useUserStore.setState({ userId: data.userId });

  const abType = await getAbType();

  // 데이터독 userId 설정
  datadogRum.setUser({
    id: data.userId,
    discoverType: abType,
  });
};

// 콜백 타입과 핸들러 매핑
const callbackHandlers: Record<string, (data: any) => void> = {
  GET_TOKEN: handleGetToken,
  UPDATE_TOKEN: handleUpdateToken,
  GET_NAME: handleGetName,
  REFRESH_VIEW: handleRefreshView,
  SET_THEME: handleSetTheme,
  GET_THEME: handleGetTheme,
  GET_TEXT_MODE: handleGetTextMode,
  GET_CONFIG: handleGetConfig,
};

export const nativeCallBack = () => {
  (window as any).callback = (jsonString: string) => {
    logger.debug('Raw data received from native:', jsonString);
    try {
      const jsonObject = JSON.parse(jsonString);
      logger.debug('response native callBack : ', jsonObject);

      const handler = callbackHandlers[jsonObject.type];
      if (handler) {
        handler(jsonObject.data);
      } else {
        logger.warn(`Unhandled callback type : ${jsonObject.type}`);
      }
    } catch (error) {
      logger.error('web : JSON parsing error:', error);
    }
  };
};
